import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { FireflyChipModule, FireflyListModule, FireflySuggesterModule } from '@capital-access/firefly/components';
import { COMMON_COMPONENTS_LOCALIZATION_SCOPE } from '../../common-components.const';
import { MultipleMasterSuggesterComponent } from './multiple-master-suggester.component';

@NgModule({
  imports: [
    CommonModule,
    FireflySuggesterModule,
    FireflyListModule,
    FireflyChipModule,
    CommonLocalizationModule.forFeature(COMMON_COMPONENTS_LOCALIZATION_SCOPE)
  ],
  declarations: [MultipleMasterSuggesterComponent],
  exports: [MultipleMasterSuggesterComponent]
})
export class MultipleMasterSuggesterModule {}
